export default __webpack_public_path__ + "static/media/img1.070211b1.jpg";